import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "app/static/frontend/components/stylus/BillStatusTimeline.styl"

export const BillStatusTimeline = (props) => {
    const getSteps = () =>
        props.currentGeneralStatusEnum.map(status => (
            <i
                className={classNames(
                    "timeline-item",
                    { "timeline-item-completed": props.currentGeneralStatus >= status.value }
                )}
                data-title={status.short_label || status.label}
                key={status.value}
            >
                <div
                    className={classNames(
                        "timeline-item-pdf-text",
                        { completed: props.currentGeneralStatus >= status.value }
                    )}
                >
                    {status.short_label || status.label}
                </div>
            </i>
        ))

    let widthVal = -1
    props.currentGeneralStatusEnum.forEach((el, i) => {
        if (el.value === props.currentGeneralStatus) {
            widthVal = i
        }
    })

    return (
        <div className="bill-status-timeline">
            <div className="bill-status-timeline-inner">
                <div
                    className={`completed-inner completed-inner-${props.currentGeneralStatus}`}
                    style={{ width: `${((widthVal) / (props.currentGeneralStatusEnum.length - 1)) * 100}%` }}
                />
                { getSteps() }
            </div>
        </div>
    )
}

BillStatusTimeline.propTypes = {
    currentGeneralStatus: PropTypes.number,
    currentGeneralStatusEnum: PropTypes.array,
}

export default BillStatusTimeline
